<div id="divChart">
    <canvas id="myChart"></canvas>
</div>